export default __webpack_public_path__ + "static/media/Mazda.6cf6e2ab.png";